import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { AccountType } from '../enums/account-type';

@Injectable({
  providedIn: 'root',
})
export class AccountTypeCssProviderService {
  /* prettier-ignore */
  private entries = new Map<AccountType, string>([
    [AccountType.Company, 'bg-indigo-50 text-indigo-700 ring-indigo-700/10'],
    [AccountType.User, 'bg-green-50 text-green-700 ring-green-600/20'],
  ]);

  public css(type: AccountType): Observable<string> {
    const result = this.entries.get(type);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The css classes for "${type}" not found.`,
      );
    }

    return of(result);
  }
}
